import * as React from 'react';

import * as styles from './TagLayout.css';
import { Spinner } from '@cian/ui-kit';

export const TagLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  // Сделан отложенный рендер для улучшения CLS:
  // Без этого теги рендерятся сперва все, а потом сворачиваются в одну строку
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    setIsLoading(false);
  }, []);

  return (
    <div className={styles['container']} data-testid="TagLayout">
      {isLoading && (
        <div className={styles['loader']}>
          <Spinner size={20} />
        </div>
      )}
      {!isLoading && children}
    </div>
  );
};
